<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.warningForCreditLimit) {
    <div class="alert alert-danger">Warning credit limit for customer passed 80%.</div>
  }
  <div class='sheet'>
    <h1 class='header'>Create a new simplified order</h1>
    <app-simplified-ordering-form [tipSite]="this.tipSite" [materialUplifts]='this.materialUplifts' [account]='this.account' [site]='this.site' [order]='this.order' [orderLines]='this.orderLines'></app-simplified-ordering-form>
    <button type="submit" class="btn btn-success" (click)='onSubmit()'>Save</button>&nbsp;
    <button type="button" class="btn btn-danger" routerLink='/orders'>Cancel</button>
  </div>
</div>
